<script>
import { answer_type } from "@/helpers/global.variable";
import { required } from "vuelidate/lib/validators";
import { authComputed } from "@/state/helpers";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import hkService from "@/helpers/APIService/hk.service";

export default {
  components: {},
  data() {
    return {
      answer_type,
      input_type: "text",
      current_answer_type: "text",
      fields: [{ id: 1 }],
      isBtnLoading: false,
      health_question: {
        is_required: true,
        is_editable: true,
        question_text: "",
        answer_type: "text",
        id: null,
        is_edit: false,
        form_data: {
          max: 20,
          min: 10,
        },
        form_data_options: [
          {
            option: null,
          },
        ],
      },
      isError: false,
      errorMessages: null,
      submitted: false,
      isSaveAndAddNew: false,
    };
  },
  props: {
    currentProps: Object,
  },
  emits: ["submitted", "saveAndAddNew", "cancelSubmit"],
  computed: {
    ...authComputed,
  },
  mounted() {
    this.isEditQuestion();
  },
  methods: {
    updateAnswerTypeOption() {
      this.health_question.answer_type = this.health_question.answer_type;
    },
    AddFormData() {
      this.health_question.form_data_options.push({ option: null });
    },
    deleteRow(index) {
      if (confirm("Are you sure you want to delete this element?"))
        this.health_question.form_data_options.splice(index, 1);
    },
    // Method is for add and update health question
    onSubmit() {
      this.submitted = true;
      this.isBtnLoading = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.isBtnLoading = false;
        return;
      } else {
        let QuestionData = new FormData();
        QuestionData.append("is_required", this.health_question.is_required);
        QuestionData.append("is_editable", this.health_question.is_editable);
        QuestionData.append(
          "question_text",
          this.health_question.question_text
        );
        QuestionData.append("answer_type", this.health_question.answer_type);
        if (
          this.health_question.answer_type == "multi_select" ||
          this.health_question.answer_type == "choice"
        ) {
          QuestionData.append(
            "form_data",
            JSON.stringify(this.health_question.form_data_options)
          );
        } else {
          QuestionData.append(
            "form_data",
            JSON.stringify(this.health_question.form_data)
          );
        }
        QuestionData.append("is_active", true);
        QuestionData.append("priority_order", 1);
        QuestionData.append("hotel", this.hotel.id);

        if (this.health_question.is_edit == false) {
          hkService
            .createHealthQuestion(QuestionData)
            .then((question) => {
              this.isBtnLoading = false;
              Middleware.notification("Added successfully !!", "success", 3000);

              this.submitted = false;
              if (!this.isSaveAndAddNew) {
                this.$emit("submitted", question);
              } else {
                this.$emit("saveAndAddNew", question);
                this.health_question = {
                  is_required: true,
                  is_editable: true,
                  question_text: "",
                  answer_type: "text",
                  id: null,
                  is_edit: false,
                  form_data: {
                    max: 20,
                    min: 10,
                  },
                  form_data_options: [
                    {
                      option: null,
                    },
                  ],
                };
              }
            })
            .catch((error) => {
              this.isBtnLoading = false;
              errorHandler(error);
            });
        } else {
          hkService
            .updateHealthQuestion(this.health_question.id, QuestionData)
            .then((question) => {
              this.isBtnLoading = false;
              Middleware.notification(
                "Successfully updated !!",
                "success",
                3000
              );
              this.submitted = false;
              this.$emit(
                "submitted",
                question,
                this.currentProps.questionEdit,
                this.currentProps.questionIndex
              );
            })
            .catch((error) => {
              this.isBtnLoading = false;
              errorHandler(error);
            });
        }
      }
    },
    saveAndAddNew() {
      this.isSaveAndAddNew = true;
      this.onSubmit();
    },
    // Method is use for cancel form
    cancelSubmit() {
      this.$emit("cancelSubmit");
      this.isSaveAndAddNew = false;
    },
    // Method is for update question
    isEditQuestion() {
      if (this.currentProps.questionEdit == true) {
        hkService
          .getHealthQuestionDetails(this.currentProps.selectedQuetionId)
          .then((response) => {
            this.health_question.id = this.currentProps.selectedQuetionId;
            this.health_question.is_edit = this.currentProps.questionEdit;
            this.health_question.is_required = response.is_required;
            this.health_question.is_editable = response.is_editable;
            this.health_question.question_text = response.question_text;
            this.health_question.answer_type = response.answer_type;
            if (
              this.health_question.answer_type == "multi_select" ||
              this.health_question.answer_type == "choice"
            ) {
              this.health_question.form_data_options = response.form_data;
            } else {
              this.health_question.form_data.min = response.form_data.min;
              this.health_question.form_data.max = response.form_data.max;
            }
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
    },
  },
  validations: {
    health_question: {
      question_text: {
        required,
      },
      answer_type: {
        required,
      },
    },
  },
};
</script>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <h4>
          {{
            !this.currentProps.questionEdit
              ? "Add New Question"
              : "Update Question"
          }}
        </h4>
        <hr />
        <div class="float-end">
          <b-form-checkbox
            class="mb-2"
            plain
            v-model="health_question.is_required"
            >Required<i
              class="mdi mdi-information-outline"
              v-b-popover.hover="'Question is required.'"
            ></i
          ></b-form-checkbox>
        </div>
        <label for="question"
          >Question <span class="text-danger">*</span></label
        >
        <textarea
          id="question"
          class="form-control"
          rows="3"
          placeholder="Add your question's here... 
            Like : What.. ? , Where.. ? , How.. ?  etc. "
          v-model="health_question.question_text"
          :class="{
            'is-invalid': submitted && $v.health_question.question_text.$error,
          }"
        ></textarea>
        <div
          v-if="submitted && $v.health_question.question_text.$error"
          class="invalid-feedback"
        >
          <span v-if="!$v.health_question.question_text.required"
            >Question is required.</span
          >
        </div>

        <div class="row">
          <div class="col-md-12 mt-3">
            <b-form-group
              class="mb-3 form-label"
              id="input-group-1"
              label="Answer Type"
              label-for="answer_type"
            >
              <span slot="label"
                >Answer Type <span class="text-danger">*</span></span
              >
              <b-form-select
                class="form-select"
                id="answer_type"
                type="text"
                autocomplete="off"
                v-model="health_question.answer_type"
                :options="answer_type"
                @change="updateAnswerTypeOption"
                :class="{
                  'is-invalid':
                    submitted && $v.health_question.answer_type.$error,
                }"
              >
              </b-form-select>
            </b-form-group>
            <div
              v-if="submitted && $v.health_question.answer_type.$error"
              class="invalid-feedback"
            >
              <span v-if="!$v.health_question.answer_type.required"
                >Please select answer type.</span
              >
            </div>
          </div>
        </div>

        <!-- options -->
        <div
          class="row option_parts"
          id="options_title"
          v-if="
            health_question.answer_type == 'multi_select' ||
            health_question.answer_type == 'choice'
          "
        >
          <div class="editable-title">
            Answers <span class="text-danger">*</span>
          </div>
          <p>Customer can select one of the following:</p>
          <div
            v-for="(field, index) in health_question.form_data_options"
            :key="index"
            class="mb-2"
          >
            <div class="row align-items-center">
              <div class="col-lg-1 editable-title text-center">
                <h5 class="mb-0">{{ index + 1 }}</h5>
              </div>

              <div class="col-lg-4">
                <input
                  id="text"
                  v-model="field.option"
                  type="text"
                  autocomplete="off"
                  placeholder="Option"
                  class="form-control"
                />
              </div>
              <div class="col-lg-2">
                <a href="#" @click="deleteRow(index)">
                  <i class="fa fa-trash-alt text-danger editable-title"></i>
                </a>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 mt-3">
              <a
                id="add_new_option"
                class="fw-bold option_parts cursor"
                @click="AddFormData"
                >+ Add Another</a
              >
            </div>
          </div>
        </div>

        <!-- additional options -->
        <div class="row">
          <div class="col-md-12 mt-2">
            <div role="tablist">
              <b-card no-body>
                <b-card-header header-tag="header" role="tab">
                  <h5 class="m-0">
                    <a
                      v-b-toggle.addition_question
                      class="text-dark"
                      href="javascript: void(0);"
                      >Additional Option</a
                    >
                  </h5>
                </b-card-header>
                <b-collapse
                  id="addition_question"
                  visible
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <b-card-body>
                    <b-card-text>
                      <!-- is editable field -->
                      <div class="col-md-12">
                        <div
                          class="d-flex align-items-center justify-content-between editable-div"
                        >
                          <div class="editable-title">Editable</div>
                          <div class="div-toggle">
                            <div class="form-check form-switch form-switch-md">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                v-model="health_question.is_editable"
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- short text -->
                      <div v-if="health_question.answer_type == 'text'">
                        <div class="col-md-12 mt-3">
                          <b-form-group
                            class="mb-3"
                            label="Minimum Character"
                            label-for="min_char"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="min_char"
                              type="number"
                              autocomplete="off"
                              min="1"
                              v-model="health_question.form_data.min"
                            ></b-form-input>
                          </b-form-group>
                          <b-form-group
                            class="mb-3"
                            label="Maximum Character"
                            label-for="max_char"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="max_char"
                              type="number"
                              autocomplete="off"
                              min="1"
                              v-model="health_question.form_data.max"
                            ></b-form-input>
                          </b-form-group>
                        </div>
                      </div>

                      <!-- date -->
                      <div
                        class="row mt-3 date"
                        v-else-if="health_question.answer_type == 'date'"
                      >
                        <div class="col-md-12">
                          <b-form-group
                            class="mb-3"
                            label="Minimum Date"
                            label-for="min_date"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="min_date"
                              type="date"
                              v-model="health_question.form_data.min"
                            ></b-form-input>
                          </b-form-group>
                          <b-form-group
                            class="mb-3"
                            label="Maximum Date"
                            label-for="max_date"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="max_date"
                              type="date"
                              v-model="health_question.form_data.max"
                            ></b-form-input>
                          </b-form-group>
                        </div>
                      </div>

                      <!-- number -->
                      <div
                        class="row mt-3 number"
                        v-else-if="health_question.answer_type == 'number'"
                      >
                        <div class="col-md-12">
                          <b-form-group
                            class="mb-3"
                            label="Minimum Number"
                            label-for="min_num"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="min_num"
                              type="number"
                              autocomplete="off"
                              value="10"
                              min="1"
                              v-model="health_question.form_data.min"
                            ></b-form-input>
                          </b-form-group>
                          <b-form-group
                            class="mb-3"
                            label="Maximum Number"
                            label-for="max_num"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="max_num"
                              type="number"
                              autocomplete="off"
                              value="20"
                              min="1"
                              v-model="health_question.form_data.max"
                            ></b-form-input>
                          </b-form-group>
                        </div>
                      </div>

                      <!-- long text -->
                      <div
                        class="row mt-3 long_text"
                        v-else-if="health_question.answer_type == 'long_text'"
                      >
                        <div class="col-md-12">
                          <b-form-group
                            class="mb-3"
                            label="Minimum Character"
                            label-for="min_char"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="min_char"
                              type="number"
                              autocomplete="off"
                              min="1"
                              v-model="health_question.form_data.min"
                            ></b-form-input>
                          </b-form-group>
                          <b-form-group
                            class="mb-3"
                            label="Maximum Character"
                            label-for="max_char"
                            label-cols-sm="3"
                          >
                            <b-form-input
                              id="max_char"
                              type="number"
                              autocomplete="off"
                              min="1"
                              v-model="health_question.form_data.max"
                            ></b-form-input>
                          </b-form-group>
                        </div>
                      </div>
                    </b-card-text>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
          </div>
        </div>
        <!-- save button div -->
        <div class="row">
          <div class="col-md-12">
            <b-button
              class="float-end ms-2"
              variant="outline-primary"
              type="reset"
              @click="cancelSubmit"
              >Cancel</b-button
            >
            <b-button
              v-if="currentProps.questionEdit === false"
              class="float-end ms-2"
              variant="outline-primary"
              type="submit"
              @click="saveAndAddNew"
              :class="{
                disabled: isSaveAndAddNew === true && isBtnLoading,
              }"
            >
              <i
                v-if="isSaveAndAddNew === true && isBtnLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i
              >Save & Add</b-button
            >
            <b-button
              class="float-end"
              variant="outline-primary"
              type="submit"
              @click="onSubmit"
              :class="{
                disabled: isSaveAndAddNew !== true && isBtnLoading,
              }"
            >
              <i
                v-if="isSaveAndAddNew !== true && isBtnLoading"
                class="bx bx-loader bx-spin font-size-16 align-middle me-2"
              ></i>
              {{ currentProps.questionEdit ? "Update" : "Save" }}
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
